import { useEffect, useState } from 'react';

/**
 * Adds a script tag to the document and returns its load/error states
 *
 * NOTE: You may want to modify this if you don't want async and defer attributes to be true
 */
function useScript(src: string, crossOrigin?: boolean) {
  const [loaded, setLoaded] = useState<boolean>(false);
  const [hasError, setHasError] = useState<boolean>(false);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.defer = true;

    if (crossOrigin) {
      script.crossOrigin = 'anonymous';
    }

    /* istanbul ignore next: tested manually */
    const onScriptLoad = () => {
      setLoaded(true);
      setHasError(false);
    };

    /* istanbul ignore next: tested manually */
    const onScriptError = () => {
      setHasError(true);
      setLoaded(true);
    };

    script.addEventListener('load', onScriptLoad);
    script.addEventListener('error', onScriptError);

    /* istanbul ignore else: empty else clause */
    if (typeof window !== 'undefined') {
      document.body.appendChild(script);
    }

    return () => {
      script.removeEventListener('load', onScriptLoad);
      script.removeEventListener('error', onScriptError);
      document.body.removeChild(script);
    };
  }, [src, crossOrigin]);

  return [loaded, hasError];
}

export default useScript;
